import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

const companiesData = {
  "This Week": [
    {
      name: "Pitch",
      date: "05 April, 2025",
      amount: 3655,
      img: "/assets/img/company/company-24.svg",
    },
    {
      name: "Initech",
      date: "05 May, 2025",
      amount: 2185,
      img: "/assets/img/company/company-25.svg",
    },
    {
      name: "Umbrella Corp",
      date: "29 April, 2025",
      amount: 1583,
      img: "/assets/img/company/company-26.svg",
    },
    {
      name: "Capital Partners",
      date: "23 Mar, 2025",
      amount: 6584,
      img: "/assets/img/company/company-27.svg",
    },
    {
      name: "Massive Dynamic",
      date: "23 Feb, 2025",
      amount: 2153,
      img: "/assets/img/company/company-28.svg",
    },
  ],
  "This Month": [
    {
      name: "Pitch",
      date: "10 April, 2025",
      amount: 4200,
      img: "/assets/img/company/company-24.svg",
    },
  ],
  "This Year": [
    {
      name: "Capital Partners",
      date: "01 Jan, 2025",
      amount: 9500,
      img: "/assets/img/company/company-27.svg",
    },
  ],
};

export default function DealsByCompanies() {
  const [filter, setFilter] = useState("This Week");

  return (
    <Card className="deals-card-header  shadow-sm h-100">
      {/* Header */}
      <Card.Header className="d-flex justify-content-between card-header-custom align-items-center bg-white border-bottom">
        <h5 className="mb-0 fw-semibold">Deals By Companies</h5>

        <Dropdown>
          <Dropdown.Toggle className="custom-dropdown">
            <FiCalendar className="me-2" />
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu className="custom-menu">
            {Object.keys(companiesData).map((item) => (
              <Dropdown.Item
                key={item}
                active={filter === item}
                onClick={() => setFilter(item)}
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      {/* Body */}
      <Card.Body className="p-3">
        {companiesData[filter].map((item, index) => (
          <div key={index} className="company-row d-flex justify-content-between align-items-center">
            
            {/* Left */}
            <div className="d-flex align-items-center">
              <div className="logo-box">
                <img src={item.img} alt="" />
              </div>

              <div className="ms-3">
                <h6 className="mb-1 fw-semibold">{item.name}</h6>
                <p className="mb-0 text-muted small">
                  Closing Deal date {item.date}
                </p>
              </div>
            </div>

            {/* Right */}
            <h6 className="amount mb-0">${item.amount}</h6>
          </div>
        ))}
      </Card.Body>

      {/* Styles */}
      <style>{`
        .deals-card-header {
          border-radius:5px;
border:2px solid #e5e7eb;
        }

        
      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

        .company-row {
          background: #f9fafb;
          border: 1px dashed #e5e7eb;
          border-radius: 10px;
          padding: 8px;
          margin-bottom: 12px;
        }

        .logo-box {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: #f3f4f6;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .logo-box img {
          width: 22px;
          height: 22px;
        }

        .amount {
          color: #1e293b;
          font-weight: 600;
        }

        /* Dropdown */
        .custom-dropdown {
          background: #fff !important;
          border: 1px solid #e5e7eb !important;
          color: #111827 !important;
          font-size: 14px;
          border-radius: 8px;
          padding: 6px 12px;
        }

        .custom-dropdown:hover {
          border-color: #f97316 !important;
          color: #f97316 !important;
        }

        .custom-menu {
          border-radius: 8px;
          padding: 6px;
        }

        .dropdown-item {
          border-radius: 6px;
          font-size: 14px;
        }

        .dropdown-item.active,
        .dropdown-item:active {
          background: #f97316 !important;
          color: #fff !important;
        }

        .dropdown-item:hover {
          background: #fff7ed;
          color: #f97316;
        }
          .dropdown-toggle::after {
  display: none !important;
}

        /* Responsive spacing */
        @media (max-width: 1024px) {
          .deals-card {
            margin-top: 15px;
          }
        }
      `}</style>
    </Card>
  );
}